import { ErrorContext } from '@/context/ErrorContext';
import { ValidationError } from '@/types/validation';
import { useState } from 'react';

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [errors, setErrors] = useState<ValidationError[]>([]);

  return (
    <ErrorContext.Provider
      value={{
        errors: errors,
        setErrors: setErrors
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
};
